module.exports = __webpack_public_path__ + "img/c2.4add1d02.svg";